import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import GatewayRedisAndLogisticsInfoComponent from './gateway-redis-logistics-info.component';
import storePersist from '../../../../../../redux/storePersist';

export default function GatewaySettingsInfoComponent({ stores, domains, channelsList, handleFormChange, selectedGateway }: any) {
  // console.log('domains', domains)
  const tenant = storePersist?.get("metaTokenMetaData")?.current?.items?.Website?.OUName;

  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Gateway"
              name="Gateway"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Gateway',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Gateway}
            />
            <InputContainer
              label="Registry"
              name="Registry"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Registry',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Registry}
            />
            <InputContainer
              label="BAP Id"
              name="BapId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BapId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BapId}
            />
            <InputContainer
              label="bap Url"
              name="BapUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BapUri',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BapUri}
            />
            <InputContainer
              label="bpp Id"
              name="BppId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BppId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BppId}
            />
            <InputContainer
              label="bpp Url"
              name="BppUri"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.BppUri',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.BppUri}
            />
            {/* <InputContainer
              label="Domain"
              name="Domain"
              labelField="Name"
              list={domains}
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Domain',
                  selectedGateway?.Settings
                )
              }}
              type="select"
              value={selectedGateway?.Settings?.Domain}
              valueField={"Code"}
            />
            <InputContainer
              label="Port"
              name="Port"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Port',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Port}
            />
            <InputContainer
              label="Core Version"
              name="CoreVersion"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.CoreVersion',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.CoreVersion}
            /> */}
            <InputContainer
              label="Tenant"
              name="Tenant"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Tenant',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              defaultValue={tenant}
              value={selectedGateway?.Settings?.Tenant}
            />
            <InputContainer
              label="Requester"
              name="Requester"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.Requester',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.Requester}
            />
            <InputContainer
              label="Store"
              labelField="StoreName"
              list={stores}
              onValueChange={(event: any, newValue: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.StoreId',
                  selectedGateway?.Settings
                )
              }}
              optionName='Choose Store'
              type="select"
              value={selectedGateway?.Settings?.StoreId}
              valueField="Id"
            />
            <InputContainer
              label="Channel Name"
              name="ChannelName"
              labelField="SalesChannelName"
              list={channelsList}
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.ChannelId',
                  selectedGateway?.Settings
                )
                handleFormChange(
                  channelsList.find(o=>o.Id === event.target.value)?.SalesChannelName,
                  'Settings.ChannelName',
                  selectedGateway?.Settings
                )
              }}
              optionName='Choose Channel'
              type="select"
              value={selectedGateway?.Settings?.ChannelId}
              valueField="Id"
            />
            <InputContainer
              label="Internal Account Id"
              name="InternalAccountId"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.InternalAccountId',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.InternalAccountId}
            />
            <InputContainer
              label="Email Domain"
              name="EmailDomain"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.EmailDomain',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.EmailDomain}
            />
            <InputContainer
              label="Default User Email"
              name="DefaultUserEmail"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.DefaultUserEmail',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.DefaultUserEmail}
            />
            <InputContainer
              label="Default User Phone"
              name="DefaultUserPhone"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.DefaultUserPhone',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.DefaultUserPhone}
            />
            <InputContainer
              //  isDisabled
              label="Secret Key"
              name="SecretKey"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.SecretKey',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.SecretKey}
            />
            <InputContainer
              //  isDisabled
              label="Ondc Token"
              name="OndcToken"
              onValueChange={(event: any) => {
                handleFormChange(
                  event.target.value,
                  'Settings.OndcToken',
                  selectedGateway?.Settings
                )
              }}
              type="text"
              value={selectedGateway?.Settings?.OndcToken}
            />
          </div>
        }
        expandedPanel="Settings Info"
        headerTitle="Retail Settings"
      />

      <GatewayRedisAndLogisticsInfoComponent 
            handleFormChange={handleFormChange}
            selectedGateway={selectedGateway}
            domainsList={domains}
            />
    </>
  )
}